import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { BaseResponse } from '../shared/models/base-api-response.interface';
import { HttpClient } from '@angular/common/http';
import { AlertService } from '../shared/services/alert.service';
import { Router } from '@angular/router';
import { Login } from '../components/login/models/login.interface';
import { environment as env } from 'src/environments/environment';
import { endpoint, httpOptions } from '../shared/apis/endpoint';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private isAuthenticated: boolean = false;
  private user: BehaviorSubject<any | null>;

  constructor(
    private http: HttpClient,
    private _alert: AlertService,
    private router: Router,
  ) {
    const token = localStorage.getItem('token');
    if (token) {
      this.user = new BehaviorSubject<BaseResponse | null>(null);
      this.isAuthenticated = true;
    } else {
      this.user = new BehaviorSubject<BaseResponse | null>(null);
      this.isAuthenticated = false;
    }
  }

  Login(req: Login): Observable<any> {
    const requestUrl = `${env.api}${endpoint.LOGIN}`;
    return this.http.post<any>(requestUrl, req, httpOptions).pipe(
      map((resp: any) => {
        if (resp.status === 200 && resp.data?.token) {
          const token = resp.data.token;
          localStorage.setItem('token', token);
          localStorage.setItem('token_type', resp.data.token_type);
          this.isAuthenticated = true;
          this.user.next(resp.data);
          this._alert.success('Bienvenido', 'Acceso correcto');
        } else {
          this._alert.warn(
            'Advertencia',
            resp.message || 'Error al iniciar sesión',
          );
        }
        return resp;
      }),
    );
  }

  getUserData(): Observable<any> {
    const requestUrl = `${env.api}${endpoint.ME}`;
    return this.http.get<any>(requestUrl, httpOptions).pipe(
      tap({
        next: (resp: any) => {
          if (resp.data) {
            this.user.next(resp.data);
          } else {
            this.user.next(resp);
          }
        },
        error: (error) => {
          console.error('Error al obtener datos del usuario:', error);
          if (error.status === 401) {
            this.logout();
          }
        },
      }),
    );
  }
  logout(): void {
    const requestUrl = `${env.api}${endpoint.LOGOUT}`;
    this.http.post(requestUrl, {}, httpOptions).subscribe({
      next: (resp: any) => {
        if (resp.status === 200) {
          this._alert.success('Éxito', 'Sesión cerrada correctamente');
        }
        this.clearSession();
      },
      error: (error) => {
        console.error('Error al cerrar sesión:', error);
        this._alert.error(
          'Error',
          'No se pudo cerrar la sesión en el servidor',
        );
        this.clearSession();
      },
    });
  }

  get currentUser$(): Observable<any> {
    return this.user.asObservable();
  }
  get currentUserValue(): any {
    return this.user.value;
  }
  private clearSession(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('token_type');
    this.isAuthenticated = false;
    this.user.next(null);
    this.router.navigate(['/login']);
  }

  isLoggedIn(): boolean {
    return this.isAuthenticated || !!localStorage.getItem('token');
  }

  resetPassword(userId: string, password: string): Observable<any> {
    const requestUrl = `${env.api}/users/${userId}/reset-password`;
    const body = { password: password };

    return this.http.put(requestUrl, body, httpOptions).pipe(
      map((resp: any) => {
        if (resp.status === 200) {
          this._alert.success('Éxito', 'Contraseña restablecida correctamente');
        } else {
          this._alert.error(
            'Error',
            resp.message || 'No se pudo restablecer la contraseña',
          );
        }
        return resp;
      }),
    );
  }
}
